// TODO move to auth module
export enum GrantStatusType {
    NOT_SET,
    GRANTED,
    DENIED,
}
